// import http from './../../../base/api/public'
// let service = require('@/../config/serviceList')
// let sysConfig = require('@/../config/sysConfig')
// let apiPre = sysConfig.apiPre
// service.res = ''
// export default {
//   getCards (params) {
//     console.log('params:' + JSON.stringify(params))
//     return http.requestPost(apiPre + service.res + '/card/getList', params)
//   }
// }
// 导入基本公共资源
import http from './../../../base/api/public'
let sysConfig = require('@/../config/sysConfig')
let service = require('@/../config/serviceList')
// 定义访问网关的api,分为开发，测试，以及生产环境
let apiPre = sysConfig.apiPre
export default {
  // 枪
  getGunsPage(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/gun/getGunsPage', params)
  },
  getGunsPageList(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/gun/getList', params)
  },
  exportCode(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestDownloadExcel(apiPre + service.res + '/res/gun/exportCode', params)
  },
  saveOrUpdateGun(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/gun/saveOrUpdateGun', params)
  },
  saveOrUpdateGunEdit(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/gun/saveOrUpdateGunEdit', params)
  },
  saveOrUpdateGunBatch(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPut(apiPre + service.res + '/res/gun/saveOrUpdateGunBatch', params)
  },
  deleteGun(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/gun/deleteGun', params)
  },
  getRealtimeGunsInfoByGunCode(params){
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/gun/getRealtimeGunsInfoByGunCode', params)
  },
  getGunEnum() {
    return http.requestGet(apiPre + service.res + '/res/gun/getGunEnum')
  },
  getQRCode(params) {
    return http.requestPost(apiPre + service.res + '/res/gun/qrcode', params)
  },
  getRateSelectByOperatorId(params) {
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/rate/getRateSelectByOperatorId', params)
  },
  remotelyStop(params){
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/deviceControl/remotelyStop', params)
  },
  sendRate(params){
    console.log('params:' + JSON.stringify(params))
    return http.requestPost(apiPre + service.res + '/res/deviceControl/sendRate', params)
  },
  sendQRCode(params) {
    return http.requestPost(apiPre + service.res + '/res/deviceControl/sendQrCode', params)
  },
}



// WEBPACK FOOTER //
// ./src/module/resourceCenter/api/gunApi.js